import { jsx as _jsx } from "react/jsx-runtime";
// -------------------------------------------------------
// NOTE: This is a generated file, do not manually modify!
// -------------------------------------------------------
import { SvgIcon } from '@mui/material';
const paths = [
    'M10.7926 8.75L11.1254 6.57734H9.04181V5.16875C9.04181 4.57578 9.33243 3.99453 10.2652 3.99453H11.2121V2.14766C11.2121 2.14766 10.352 2 9.53165 2C7.81603 2 6.69337 3.04062 6.69337 4.92266V6.57734H4.7879V8.75H6.69572V14H9.04415V8.75H10.7926Z',
];
export const Facebook = (props) => (_jsx(SvgIcon, Object.assign({ viewBox: "0 0 16 16" }, props, { children: paths.map((pathString, i) => (_jsx("path", { d: pathString }, i))) })));
Facebook.iconCategory = 'socialmedia';
